<template>
  <v-progress-circular
    :color="color"
    :size="size"
    indeterminate
  />
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    size: {
      type: [Number, String],
      default: 36,
    },
  }
}
</script>